import { render, staticRenderFns } from "./updateXminfo.vue?vue&type=template&id=1f17eca0&"
import script from "./updateXminfo.vue?vue&type=script&lang=js&"
export * from "./updateXminfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports